import request from '@/apis/axios'
import type { IResponse } from '@/apis/axios/config'
import type {
  GetCategoryCodeParam,
  GetCategoryCodeResult,
  MyPassageListParam,
  MyPassageListResult,
  GetPassageDetailParam,
  GetPassageDetailResult,
  AddPassageParam,
  AddPassageResult,
  TranslatePassageParam,
  TranslatePassageResult,
  TransformPassageParam,
  TransformPassageResult,
  PreviewExamDataParam,
  PreviewExamDataResult,
  GetPassageTypeCodeParam,
  GetPassageTypeCodeResult,
  GetTransformPointResult,
} from '~/apis/data/type'

/**
 * 1.3.1 카테고리 코드 조회-완료
 * */
export const getCategoryCode = (
  data: GetCategoryCodeParam,
): Promise<IResponse<GetCategoryCodeResult>> => {
  return request.post({ url: '/jadooApiV1/getCategoryCode', data })
}

/**
 * 1.2.3 내 지문보관함 리스트(저장지문불러오기)-완료
 * */
export const getMyPassageList = (
  data: MyPassageListParam,
): Promise<IResponse<MyPassageListResult>> => {
  return request.post({ url: '/jadooApiV1/myPassageList', data })
}

/**
 * 1.2.4 지문 상세 조회(팝업용)-완료
 * */
export const getPassageDetail = (
  data: GetPassageDetailParam,
): Promise<IResponse<GetPassageDetailResult>> => {
  return request.post({ url: '/jadooApiV1/getPassageDetail', data })
}

/**
 * 1.2.6 지문 추가-완료
 * */
export const addPassage = (
  data: AddPassageParam,
): Promise<IResponse<AddPassageResult>> => {
  return request.post({ url: '/jadooApiV1/passageManage', data })
}

/**
 * 1.2.1 지문 번역(해설) 단건 요청-완료
 * */
export const translatePassage = (
  data: TranslatePassageParam,
): Promise<IResponse<TranslatePassageResult>> => {
  return request.post({ url: '/jadooApiV1/translatePassage', data })
}

/**
 * 1.2.2 지문 변형 요청-완료
 * */
export const transformPassage = (
  data: TransformPassageParam,
): Promise<IResponse<TransformPassageResult>> => {
  return request.post({ url: '/jadooApiV1/changePassages', data })
}

/**
 * 1.1.5 문제 미리보기 조회-완료
 * */
export const examPreview = (): Promise<IResponse<PreviewExamDataResult>> => {
  return request.get({ url: '/jadooApiV1/previewInfo' })
}

/**
 * 지문 타입 코드 조회
 * */
export const getPassageTypeCode = (
  data?: GetPassageTypeCodeParam,
): Promise<IResponse<GetPassageTypeCodeResult>> => {
  return request.post({
    url: '/jadooApiV1/getPassageTypeCode',
    data: data || {},
  })
}

/**
 * 변형 포인트 조회
 * */
export const getTransformPoint = (): Promise<
  IResponse<GetTransformPointResult>
> => {
  return request.post({ url: '/jadooApiV1/getTransformPoint', data: {} })
}
